import React from 'react';
import PrivateRoute from 'PrivateRoutes';
const HelpCenterFile = React.lazy(() => import(/* webpackChunkName: "HelpCenterFile" */'./components'));
const routes = () => [
    <PrivateRoute
        key="/settings/help-center/page/:_id"
        exact
        path="/settings/help-center/page/:_id"
        component={({ location, match }) => {
            console.log('location', location)
            const helpCenterId = location.state ? location.state.helpCenterId : ""
            return <HelpCenterFile parentId={match.params._id} helpCenterId={helpCenterId} />;
        }}
    />
];

export default routes;



// WEBPACK FOOTER //
// src/modules/screens/settings/HelpCenterFile/routes.js